import { render, staticRenderFns } from "./UnitCustomerModal.vue?vue&type=template&id=12a1dc70&"
import script from "./UnitCustomerModal.vue?vue&type=script&lang=js&"
export * from "./UnitCustomerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports